// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ProfilePhotoInput = require("../common/ProfilePicture/ProfilePhotoInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let AgentMarketingProfilePhotoFormMutation_graphql = require("../../__generated__/AgentMarketingProfilePhotoFormMutation_graphql.bs.js");
let AvatarDefaultSvg = require("../../../assets/images/elements/avatar-default.svg");
let AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.bs.js");
let AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.bs.js");
let AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.bs.js");

let convertFragment = AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let avatarPlaceholder = AvatarDefaultSvg;

function AgentMarketingProfilePhotoForm$CurrentPhoto(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let profilePicture = marketingProfile.profilePicture;
  let src = profilePicture !== undefined ? profilePicture.url : avatarPlaceholder;
  let match = marketingProfile.profilePicture;
  let alt = match !== undefined ? "Your current profile picture" : "Placeholder profile picture showing a person's silhouette";
  return JsxRuntime.jsx("img", {
    className: "w-24 h-24 rounded-full",
    alt: alt,
    src: src
  });
}

let CurrentPhoto = {
  Fragment: Fragment,
  avatarPlaceholder: avatarPlaceholder,
  make: AgentMarketingProfilePhotoForm$CurrentPhoto
};

let convertFragment$1 = AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = AgentMarketingProfilePhotoFormMutation_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfilePhotoFormMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfilePhotoFormMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfilePhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfilePhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation_imageContentType_decode = AgentMarketingProfilePhotoFormMutation_graphql.Utils.imageContentType_decode;

let Mutation_imageContentType_fromString = AgentMarketingProfilePhotoFormMutation_graphql.Utils.imageContentType_fromString;

let Mutation = {
  imageContentType_decode: Mutation_imageContentType_decode,
  imageContentType_fromString: Mutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function AgentMarketingProfilePhotoForm$ChangeProfilePhoto(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, props.marketingProfile);
  let match = use$2();
  let mutate = match[0];
  let match$1 = marketingProfile.profilePicture;
  let buttonText = match$1 !== undefined ? "Change photo" : "Add photo";
  return JsxRuntime.jsx(ProfilePhotoInput.make, {
    onSubmit: (param, param$1) => {
      let notifyOnError = param$1.notifyOnError;
      let notifyOnSuccess = param$1.notifyOnSuccess;
      mutate({
        input: {
          profilePhoto: {
            croppedPhoto: param.croppedPhoto,
            originalPhoto: param.originalPhoto
          }
        }
      }, undefined, undefined, undefined, (_response, errors) => {
        if (errors !== undefined) {
          return notifyOnError("There was an error saving your photo. Please try again.");
        } else {
          return notifyOnSuccess();
        }
      }, param => notifyOnError("There was an error saving your photo. Please try again."), undefined);
    },
    buttonText: buttonText
  });
}

let ChangeProfilePhoto = {
  Fragment: Fragment$1,
  Mutation: Mutation,
  make: AgentMarketingProfilePhotoForm$ChangeProfilePhoto
};

let convertFragment$2 = AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function AgentMarketingProfilePhotoForm$WithoutErrorBundary(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, props.marketingProfile);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Profile Picture"
            }),
            JsxRuntime.jsx("div", {
              children: "Upload a headshot to show at the top of your profile next to your name.",
              className: "text-base text-zinc-500"
            })
          ]
        }),
        className: "pt-2 col-span-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(AgentMarketingProfilePhotoForm$CurrentPhoto, {
            marketingProfile: marketingProfile.fragmentRefs
          }),
          JsxRuntime.jsx(AgentMarketingProfilePhotoForm$ChangeProfilePhoto, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "mt-2 sm:col-span-3 sm:mt-0 sm:max-w-xs flex gap-6 items-center md:flex-col lg:flex-row"
      })
    ],
    className: "sm:grid sm:grid-cols-5 sm:items-start sm:gap-16 sm:py-6 space-y-6"
  });
}

let WithoutErrorBundary = {
  make: AgentMarketingProfilePhotoForm$WithoutErrorBundary
};

function AgentMarketingProfilePhotoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Profile photo",
    children: JsxRuntime.jsx(AgentMarketingProfilePhotoForm$WithoutErrorBundary, {
      marketingProfile: props.marketingProfile
    })
  });
}

let make = AgentMarketingProfilePhotoForm;

exports.CurrentPhoto = CurrentPhoto;
exports.ChangeProfilePhoto = ChangeProfilePhoto;
exports.Fragment = Fragment$2;
exports.WithoutErrorBundary = WithoutErrorBundary;
exports.make = make;
/* avatarPlaceholder Not a pure module */
